import { Stack } from '@mui/material';

import { useFlowChartContext } from '@/components/diagrams/FlowChart/context/flowChart.context';
import { ButtonWithPopover } from '@/components/form/baseInputs/Button/ButtonWithPopover';
import { Checkbox } from '@/components/form/baseInputs/Checkbox';
import { Settings04Icon } from '@/components/icons/Settings04Icon';

import { useEntityDiagramContext } from '../contexts/entityDiagram.context';

export function EntityDiagramVizConfigSettings() {
  const { state, dispatch } = useEntityDiagramContext();
  const {
    __internal: { setIsDirty },
  } = useFlowChartContext();
  return (
    <ButtonWithPopover
      keepOpen
      label="Settings"
      size="sm"
      variant="secondary"
      hideChevron
      startIcon={Settings04Icon}
    >
      <Stack padding={1}>
        <Checkbox
          value={state.hideEntitiesListInGroups}
          label="Hide list of entities in groups"
          onChange={() => {
            dispatch({
              type: 'SET_HIDE_GROUP_CONTENTS',
              value: !state.hideEntitiesListInGroups,
            });
            setIsDirty(true);
          }}
        />
      </Stack>
    </ButtonWithPopover>
  );
}
